let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hU95F")).then(() => parcelRequire('5lo1V'));